// Libs
import * as React from 'react'
import { connect } from 'react-redux'
import { withRouter, RouteComponentProps } from 'react-router'
import styled from 'styled-components'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import Modal from '@material-ui/core/Modal'
import TextField from '@material-ui/core/TextField'
// Components
import ClassChips from './ClassChips'
import CustButton from '../shared/Button'
import FixedFabButton from '../shared/FixedFabButton'
// Store
import {
  removeBusinessLine,
  addBusinessLineRecommendation
} from './duck/actions'
// Helpers
import { IProfileState } from '../lib/interface'
import { getBusinessLineItemsFromSelections} from '../lib/helpers'
import { APP_URL } from 'src/core/constants';
import Requests from 'src/lib/requests';


interface IProps extends RouteComponentProps<{}> {
  businessLineSelections: number[]
  businessLineData: any[]
  factoidSelections: number[]
  classSelections: number[]
  profile: IProfileState
  removeBusinessLine: (id: number) => void
  addBusinessLineRecommendation: (id: number) => void
}

interface IState {
  recommendations: any[]
  modalIsOpen: boolean
  name: string
  surname: string
  email: string
  mobile: string
  company: string
  loading: boolean,
}

class Review extends React.Component<IProps, IState> {
  public state = {
    recommendations: [],
    modalIsOpen: false,
    name: '',
    surname: '',
    email: '',
    mobile: '',
    company: '',
    loading: false,
  }

  public componentDidMount() {

  if (!this.props.classSelections.length) {
      this.props.history.push('/views/new')
    } else if (!this.props.businessLineSelections.length) {
      this.props.history.push('/views/new/factoids')
    } 

    const { businessLineSelections, businessLineData } = this.props
   
    // Generate recommendations based on current BL's selected

    // Get object data of BL's that are selected
    const businessLines = getBusinessLineItemsFromSelections(
      businessLineSelections,
      businessLineData
    )

    const recommendationIds: number[] = []

    // Loop through all selected BL's and push the id's of their related BL's
    businessLines.forEach((bl: any) => {

      if (bl.acf.related_business_lines.length) {
        bl.acf.related_business_lines.forEach((bl2: any) => {
          // @ts-ignore
          if (!recommendationIds.includes(bl2.id)) {
            recommendationIds.push(bl2.term_id)
          }
        })
      }
    })

    const recommendations: any[] = businessLineData.filter(
      (bl: any) =>
        // @ts-ignore
        recommendationIds.includes(bl.id) &&
        // Filter out any related BL's that are already active
        // @ts-ignore
        !businessLineSelections.includes(bl.id)
    )

    this.setState({ recommendations })
  }

  public openModal = () => {
    this.setState({ modalIsOpen: true })
  }

  public closeModal = () => {
    this.setState({ modalIsOpen: false })
  }

  public handleFormSubmit = () => {
    this.setState({ loading: true })
    this.next()
  }

  public formIsValid = (): boolean => {
    const { name, surname, email, mobile } = this.state
    return name.length > 0 &&
      surname.length > 0 &&
      email.length > 0 &&
      mobile.length > 0
      ? true
      : false
  }

  public handleInputChange = (
    type: string,
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    const state = this.state
    state[type] = e.target.value
    this.setState(state)
  }

  public backToFactoids = () => {
    this.props.history.push('/views/new')
  }

  public handleModalClose = () => {
    this.setState({ modalIsOpen: false })
  }

  public next = async () => {
    try {
      // create the view in wordpress
      const viewCreationRes = await Requests.createView({
        title: `${this.state.name} ${this.state.surname}`,
        status: 'publish'
      });
  
      // update the view with the acf data
      await Requests.updateViewACF(viewCreationRes.data.id, {
        fields: {
          factoids: this.props.factoidSelections,
          classes: this.props.classSelections,
          business_lines: this.props.businessLineSelections
        }
      })
  
      // post lead form
      await Requests.createFormEntry({
        input_1: this.state.name,
        input_2: this.state.surname,
        input_7: this.state.email,
        input_5: this.state.mobile,
        input_6: viewCreationRes.data.id,
        input_8: this.props.profile.email,
        input_9: this.props.profile.given_name,
        input_10: `${APP_URL}/view/${viewCreationRes.data.id}`,
        input_11: this.state.company
      })
      
      this.props.history.push(`/views/new/success/${viewCreationRes.data.id}`)
    } catch (err) {
      console.log('error creating experience', err)
    } finally {
      this.setState({ loading: false })
    }
  }

  public onRecommendationAdd = (id: number) => {
    // User has added a particular recommendation, filter it out from suggestions
    const recommendations = [...this.state.recommendations].filter(
      (businessLine: any) => businessLine.id !== id
    )
    this.setState({ recommendations })

    this.props.addBusinessLineRecommendation(id)
  }

  public render() {
    const { businessLineSelections, businessLineData } = this.props

    // get relevant business line objects
    const businessLines = getBusinessLineItemsFromSelections(
      businessLineSelections,
      businessLineData
    )

    const renderCard = (item: any, type?: string) : React.ReactNode => (
      <div className="col-sm-4" key={item.id}>
        <Card
          style={{
            backgroundImage: `url(${item.acf.card_image.url})`,
            backgroundSize: 'cover',
            height: type === 'suggestion' ? '350px' : '200px',
            display: 'flex',
            alignItems: 'flex-end'
          }}
        >
          <CardContent
            style={{
              width: '100%',
              padding: '12px',
              paddingBottom: '0px',
              background: 'rgba(0,0,0,0.4)',
              display: 'flex',
              justifyContent: type === 'suggestion' ?  '' : 'space-between',
              flexDirection: type === 'suggestion' ? 'column' : 'row',
              height: '50%'
            }}
          >
            <Typography
              component="title"
              style={{ color: '#fff', fontSize: '18px', fontWeight: 300 }}
            >
              {item.name}
            </Typography>
            { type === 'suggestion' ?
            <Typography
            component="p"
            style={{ color: '#fff', paddingBottom: '20px', fontWeight: 300 }}
          >
          {item.description}
          </Typography> : null
            }

            <Button
              size="small"
              style={{ 
                color: '#fff', alignSelf: 'flex-end',
                position: type === 'suggestion' ? 'absolute' : 'initial',
                bottom: type === 'suggestion' ? '0px' : ''
             }}
              onClick={() =>
                type === 'suggestion'
                  ? this.onRecommendationAdd(item.id)
                  : this.props.removeBusinessLine(item.id)
              }
            >
              {type === 'suggestion' ? 'ADD' : 'REMOVE'}
            </Button>
          </CardContent>
        </Card>
      </div>
    )

    return (
      <Outer>
        <h2>Your Cushman &amp; Wakefield experience is almost ready</h2>
          <React.Fragment>
            <ClassChips parentsOnly={true} />
            <CardsContainer className="row">
              {businessLines.map((bl: any) => renderCard(bl))}
              <div className="col-sm-4">
                <AddCard onClick={this.backToFactoids}> + Explore another asset type</AddCard>
              </div>
            </CardsContainer>

            {this.state.recommendations.length > 0 && (
              <React.Fragment>
                <h2>
                  Based on your bundle, we think you could benefit from the
                  services below
                </h2>
                <CardsContainer className="row">
                  {this.state.recommendations.map((bl: any) =>
                    renderCard(bl, 'suggestion')
                  )}
                </CardsContainer>
              </React.Fragment>
            )}
          <FixedFabButton onClick={this.openModal} disabled={this.props.factoidSelections.length === 0}>
            <ArrowForwardIcon style={{ color: '#fff' }} />
              </FixedFabButton>
          </React.Fragment>

        <Modal
          aria-labelledby="details form"
          aria-describedby="form to capture client details"
          open={this.state.modalIsOpen}
          onClose={this.handleModalClose}
          disableAutoFocus={true}
        >
          <FormContainer>
            <div style={{ padding: '22px 0px', fontWeight: 'bold' }}>
            Create your personalised Cushman & Wakefield experience
            </div>
            <DetailsForm onSubmit={this.handleFormSubmit}>
              <TextField
                type="text"
                placeholder="First name"
                label="First name"
                onChange={e => this.handleInputChange('name', e)}
                margin="dense"
                value={this.state.name}
              />
              <TextField
                type="text"
                placeholder="Last name"
                label="Last name"
                onChange={e => this.handleInputChange('surname', e)}
                margin="dense"
                value={this.state.surname}
              />
              <TextField
                type="email"
                placeholder="Email address"
                label="Email address"
                onChange={e => this.handleInputChange('email', e)}
                margin="dense"
                value={this.state.email}
              />
              <TextField
                type="phone"
                placeholder="Mobile number"
                label="Mobile number"
                onChange={e => this.handleInputChange('mobile', e)}
                margin="dense"
                value={this.state.mobile}
              />
              <TextField
                type="text"
                placeholder="Company"
                label="Company"
                onChange={e => this.handleInputChange('company', e)}
                margin="dense"
                value={this.state.company}
              />
              <CustButton
                onButtonClick={this.handleFormSubmit}
                disabled={!this.formIsValid() || this.state.loading}
                loading={this.state.loading}
              >
                SEND
              </CustButton>
            </DetailsForm>
          </FormContainer>
        </Modal>
      </Outer>
    )
  }
}

const mapStateToProps = (state: any) => ({
  businessLineSelections: state.views.new.selections.businessLines,
  businessLineData: state.data.businessLines,
  factoidSelections: state.views.new.selections.factoids,
  classSelections: state.views.new.selections.classes,
  profile: state.profile
})

export default withRouter(
  connect(
    mapStateToProps,
    { removeBusinessLine, addBusinessLineRecommendation }
  )(Review)
)

const FormContainer = styled.div`
  background-color: #fff;
  text-align: center;
  margin: 0 auto;
  height: auto;
  width: 450px;
  max-width: 90%;
  padding: 40px;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
`


const Outer = styled.div`
  width: 95%;
  margin: 0 auto;
  padding: 20px 0px;

  /* .details-modal {
    @media screen only and (max-width: 427px) {
      width: 80%;
    }
  } */
`

const CardsContainer = styled.div`
  > div {
    margin-bottom: 20px;
  }
`

const AddCard = styled.div`
  height: 200px;
  border: 4px dashed #e0dfe0;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 20px;
  text-align: center;
  color: #a9abad;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`
const DetailsForm = styled.form`
  display: flex;
  flex-direction: column;

  button {
    width: 100px;
    margin: 25px auto 0 auto;
  }
`



// WEBPACK FOOTER //
// ./src/views/Review.tsx